const helpers = window.BASE_HELPERS || {};
const { Mobile, Copy } = helpers;

class Single {
    constructor() {
        this.offset = Mobile.isMobile() ? 99 : 124;
        this.init();
    }

    init() {
        Copy.initCopy();
        this.clickTargetH2();
    }

    clickTargetH2() {
        const itens = document.querySelectorAll('[data-title]');

        if (!itens) return;


        itens.forEach(item => {
            item.addEventListener('click', () => {
                const title = item.dataset.title;
                const target = document.querySelector(`#${title}`);

                if (target) {
                    this.scrollToTarget(target)
                }
            })
        })
    }

    scrollToTarget(target) {
        if (!target) return;

       const top =
        target.getBoundingClientRect().top +
        window.scrollY -
        this.offset -
        24;

        window.scrollTo({
            top,
            behavior: 'smooth'
        })
    }
}

(() => {
    new Single();
})();

export default Single;